import { render, staticRenderFns } from "./warnInfo.vue?vue&type=template&id=9b1e354e&scoped=true&"
import script from "./warnInfo.vue?vue&type=script&lang=js&"
export * from "./warnInfo.vue?vue&type=script&lang=js&"
import style0 from "./warnInfo.vue?vue&type=style&index=0&id=9b1e354e&scoped=true&lang=css&"
import style1 from "./warnInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1e354e",
  null
  
)

export default component.exports